import Loading from '../components/Loading';
import React, { useEffect } from 'react';
import socialAuthorize from '../actions/socialAuthorize';
import { useParams } from 'react-router-dom';
import { TIdentityProvider } from '../services/auth';

export function AuthorizeIdp() {
    const { idp } = useParams() as { idp: TIdentityProvider };
    useEffect(() => {
        socialAuthorize(idp);
    }, []);
    return <Loading />;
}

export default AuthorizeIdp;
